import { useState } from "react";
import { ArrowRightIcon } from "lucide-react";

import { LayoutRouter } from "@/layouts/LayoutRouter";
import { PublicLayout } from "@/layouts/PublicLayout";
import { State } from "@/state";
import { Typography } from "@/components/ui/typography";
import { Button } from "@/components/ui/button";
import { cn } from "@/components/ui/utils";

export default function Page() {
  const [isHovering, setIsHovering] = useState(false);
  const [email, setEmail] = useState("");
  const { setSnackbarMessage } = State((state) => ({
    setSnackbarMessage: state.setSnackbarMessage,
  }));

  return (
    <LayoutRouter
      isHorizontalPaddingIncluded={false}
      isVerticalPaddingIncluded={false}
      isFooterVisible={true}
      isPublicLayout
      isRulersIncluded={true}
      topbarMaxWidth={"xl"}
    >
      <PublicLayout
        maxWidth="xl"
        layout={{
          content: [
            {
              type: "custom",
              innerClassName: "flex flex-col items-center justify-center gap-4",
              renderTitle: () => (
                <Typography level="h2">Coming September 2023.</Typography>
              ),
              renderChildren: () => (
                <div className="flex min-w-0 flex-wrap flex-col items-center">
                  <Typography level="title-lg" className="mt-4 mb-4">
                    Join our beta list to get early access to our platform.
                  </Typography>
                  <div className="flex flex-row items-center justify-center gap-4 relative">
                    <input
                      placeholder="youare@rockstar.com"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      style={{
                        marginTop: "16px",
                        borderRadius: "48px",
                        fontSize: "2rem",
                        paddingLeft: "32px",
                        paddingRight: "80px",
                        paddingTop: "8px",
                        paddingBottom: "8px",
                        backgroundColor: "var(--accent)",
                        width: "720px",
                      }}
                    />
                    <Button
                      variant="ghost"
                      size="icon-lg"
                      onMouseEnter={() => setIsHovering(true)}
                      onMouseLeave={() => setIsHovering(false)}
                      className="absolute right-0 top-[50%] rounded-full transform-[rotate(0deg)_translate(-25%,-35%)] bg-accent"
                      onClick={() => {
                        const emailRegex = new RegExp(
                          "^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$",
                        );

                        if (!emailRegex.test(email)) {
                          // snackbar.error('Please enter a valid email address.');
                          return;
                        }

                        const apiUrl =
                          "https://api.airtable.com/v0/appLcRtEdJDbaF0vy/Waitlist";
                        const apiToken =
                          "patp9srnZ8zIWGiX1.af11f63e6d7313a3240752335b17eb1eca4e6c3423eafd07bdbbbd440e37413b";

                        const headers = {
                          Authorization: `Bearer ${apiToken}`,
                          "Content-Type": "application/json",
                        };

                        const data = {
                          records: [
                            {
                              fields: {
                                Name: "",
                                Email: email,
                              },
                            },
                          ],
                        };
                        fetch(apiUrl, {
                          method: "POST",
                          headers: headers,
                          body: JSON.stringify(data),
                        })
                          .then(() => {
                            setEmail("");
                            setSnackbarMessage(
                              "Subscribed! See you in the inbox.",
                            );
                          })
                          .catch(() => {
                            setSnackbarMessage(
                              "Unable to subscribe to newsletter.",
                            );
                          });
                      }}
                    >
                      {/* As Material's icon drew under Joy's theme: at the size of
                          the words around it, in the theme's primary. */}
                      <ArrowRightIcon
                        aria-hidden
                        focusable="false"
                        data-testid="ArrowForwardIcon"
                        className={cn(
                          "inline-block size-[1em] shrink-0 fill-current stroke-none [stroke-width:1px] select-none text-primary origin-center transform-[scale(2)] [transition:all_0.2s_ease-in-out]",
                          isHovering ? "rotate-[-30deg]" : "rotate-[0deg]",
                        )}
                      />
                    </Button>
                  </div>
                </div>
              ),
            },
          ],
        }}
      />
    </LayoutRouter>
  );
}
